import { GET_REPORTED_USERS } from '../actionTypes';

const initialState = {
  reportedUsers: []
};

const reportedUsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REPORTED_USERS:
      return {
        ...state,
        reportedUsers: action.payload
      };
    default: {
      return state;
    }
  }
};

export default reportedUsersReducer;
